/**
 * DragHandle — wspólny uchwyt (6 kropek) na klockach kreatora modułu.
 *
 * F12.N pakiet B Sub-tura 1: handle wizualny + accessible. Sub-tura 2 podepnie
 * faktyczny gest dnd-kit przez `dragHandleProps` (attributes + listeners
 * z `useSortable`).
 *
 * `<div role="button" tabIndex={0}>` zamiast natywnego `<button>` — natywny
 * guzik konsumuje `pointerdown` w sposób który blokuje gest biblioteki dnd-kit
 * (potwierdzone wczoraj na palecie modułów systemowych, F12.N E3.T1).
 */

import { type HTMLAttributes, type KeyboardEvent } from 'react';
import { GripVertical } from 'lucide-react';

export interface DragHandleProps {
  /** Tekst dla aria-label, np. „Przeciągnij pole" / „Przeciągnij sekcję Dane". */
  ariaLabel: string;
  /** Spread z `useSortable.attributes` + `useSortable.listeners` (Sub-tura 2). */
  dragHandleProps?: HTMLAttributes<HTMLDivElement>;
  /** Opcjonalna dodatkowa klasa (np. mniejszy rozmiar dla zagnieżdżonych klocków). */
  className?: string;
}

export function DragHandle({ ariaLabel, dragHandleProps, className }: DragHandleProps) {
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      dragHandleProps?.onKeyDown?.(e);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onKeyDown={onKeyDown}
      {...dragHandleProps}
      className={
        'cursor-grab rounded p-1 text-text-muted hover:bg-bg-tertiary ' + (className ?? '')
      }
    >
      <GripVertical className="h-4 w-4" aria-hidden="true" />
    </div>
  );
}
